import { Container } from '../components/Container';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
import { Seo } from '../components/Seo';
import { legalNoticeContent } from '../content';
import type { Locale } from '../content/types';
import { getSeoConfig } from '../lib/seo';

type LegalNoticePageProps = {
  locale: Locale;
};

export function LegalNoticePage({ locale }: LegalNoticePageProps) {
  const content = legalNoticeContent[locale];

  return (
    <>
      <Seo config={getSeoConfig('legal-notice', locale)} />
      <Header locale={locale} />
      <main className="legal-page">
        <Container size="narrow">
          <p className="eyebrow">{locale === 'de' ? 'Rechtliche Hinweise' : 'Legal information'}</p>
          <h1>{content.h1}</h1>
          {content.intro ? <p className="legal-page__intro">{content.intro}</p> : null}
          <div className="legal-page__sections">
            {content.sections.map((section, index) => {
              const headingId = `legal-section-${index}`;

              return (
                <section key={section.title} aria-labelledby={headingId}>
                  <h2 id={headingId}>{section.title}</h2>
                  {section.paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                  {section.contactBlock ? (
                    <address>
                      {section.contactBlock.map((line) => (
                        <span key={line}>{line}</span>
                      ))}
                    </address>
                  ) : null}
                </section>
              );
            })}
          </div>
        </Container>
      </main>
      <Footer locale={locale} />
    </>
  );
}
